import { FolderDocument } from '../server/folder-document';

export class CommentViewerRefreshEvent {
    public constructor(
        public folderId: string,
        public commentDocument: FolderDocument
    ) {}
}
